import styled from "styled-components";
import { theme } from "../../../../styles/theme";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
  overflow: auto;
`;

export const FormCard = styled.div`
  background: ${theme.colors.darkBlue};
  padding: 30px;
  border-radius: 20px;
  margin-top: 20px;
  max-width: 800px;
  width: 100%;
  align-self: center;
`;
